import * as React from 'react';

interface Props {
  className?: string;
}

const ShareIcon: React.FC<Props> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.75 0C10.9926 0 12 1.00736 12 2.25C12 3.49264 10.9926 4.5 9.75 4.5C9.14199 4.5 8.59031 4.25884 8.1854 3.86695L4.5 5.68524V6.31476L8.1854 8.13305C8.59031 7.74116 9.14199 7.5 9.75 7.5C10.9926 7.5 12 8.50736 12 9.75C12 10.9926 10.9926 12 9.75 12C8.50736 12 7.5 10.9926 7.5 9.75C7.5 9.65501 7.50589 9.5614 7.51731 9.4695L3.82785 7.60402C3.42176 8.00353 2.86466 8.25 2.25 8.25C1.00736 8.25 0 7.24264 0 6C0 4.75736 1.00736 3.75 2.25 3.75C2.86466 3.75 3.42176 3.99647 3.82785 4.39598L7.51731 2.5305C7.50589 2.4386 7.5 2.34499 7.5 2.25C7.5 1.00736 8.50736 0 9.75 0Z"
      fill="#187A90"
    />
  </svg>
);

export default ShareIcon;
